export function getBenefitRemainingBalance(
	defaultAmount: number,
	usedCount: number,
): number {
	return Math.max(0, defaultAmount - usedCount);
}

export function getBenefitHasAvailableUses(
	defaultAmount: number,
	usedCount: number,
): boolean {
	return getBenefitRemainingBalance(defaultAmount, usedCount) > 0;
}

export function getBenefitConsumptionProgress(
	defaultAmount: number,
	usedCount: number,
): number {
	if (defaultAmount <= 0 || usedCount <= 0) return 0;
	return Math.min(100, (usedCount / defaultAmount) * 100);
}

export function getBenefitConsumptionPercentageLabel(
	defaultAmount: number,
	usedCount: number,
): number {
	if (defaultAmount <= 0) return 0;
	return Math.round((usedCount / defaultAmount) * 100);
}

export function hasBenefitUsageCredit(
	_defaultAmount: number,
	usedCount: number,
): boolean {
	return usedCount < 0;
}
